import { render, staticRenderFns } from "./TipoMovVals.vue?vue&type=template&id=afd6bac0&scoped=true&"
import script from "./TipoMovVals.vue?vue&type=script&lang=js&"
export * from "./TipoMovVals.vue?vue&type=script&lang=js&"
import style0 from "./TipoMovVals.vue?vue&type=style&index=0&id=afd6bac0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd6bac0",
  null
  
)

export default component.exports